import {
    chain,
    PopulateApiParameter as basePopulateApiParameter,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { createChainHandler, replaceInChain } from "@store/Modules/client-framework/HandlerCreator";

export const PopulateApiParameter = createChainHandler("PopulateApiParameter", chain, props => {
    basePopulateApiParameter(props as any);
    props.apiParameter.additionalExpands = ["properties"];
});

replaceInChain(chain, basePopulateApiParameter, PopulateApiParameter);
